import React from "react";
import "./FirefightingToolbar.css"; // We'll create this CSS file next

const TOOLS = {
  WATER_DROP: "WATER_DROP",
  RETARDANT_DROP: "RETARDANT_DROP",
  BACKFIRE: "BACKFIRE",
  DIG_BREAK: "DIG_BREAK",
  NONE: null, // To deselect tools
};

const FirefightingToolbar = ({ selectedTool, onSelectTool }) => {
  return (
    <div className="firefighting-toolbar">
      <h4>Firefighting Tools</h4>
      <button
        className={`tool-button ${
          selectedTool === TOOLS.WATER_DROP ? "active" : ""
        }`}
        onClick={() => onSelectTool(TOOLS.WATER_DROP)}
        title="Water Drop (Extinguishes small area)"
      >
        💧 Water
      </button>
      <button
        className={`tool-button ${
          selectedTool === TOOLS.RETARDANT_DROP ? "active" : ""
        }`}
        onClick={() => onSelectTool(TOOLS.RETARDANT_DROP)}
        title="Retardant Drop (Reduces flammability)"
      >
        ✈️ Retardant
      </button>
      <button
        className={`tool-button ${
          selectedTool === TOOLS.BACKFIRE ? "active" : ""
        }`}
        onClick={() => onSelectTool(TOOLS.BACKFIRE)}
        title="Start Backfire (Burns fuel ahead of main fire)"
      >
        🔥 Backfire
      </button>
      <button
        className={`tool-button ${
          selectedTool === TOOLS.DIG_BREAK ? "active" : ""
        }`}
        onClick={() => onSelectTool(TOOLS.DIG_BREAK)}
        title="Dig Firebreak (Clears fuel, takes time)"
      >
        🚧 Dig Break
      </button>
      {selectedTool && (
        <button
          className="tool-button deselect-button"
          onClick={() => onSelectTool(TOOLS.NONE)}
          title="Deselect Tool"
        >
          ❌ Clear
        </button>
      )}
    </div>
  );
};

// Export TOOLS enum along with the component
export { FirefightingToolbar, TOOLS };
